import React from 'react';
import styled, { css } from 'styled-components';
import * as Bento from '@prezi/bento';
import * as Atoms from '../../atoms';
import { localI18n } from '../../../i18n';
const uxCopy = {
  dismissModal: localI18n._("Done")
};
const GridPrimary = styled(Atoms.Dumb.ColumnAutoMin).withConfig({
  displayName: "Footer__GridPrimary",
  componentId: "o161ez-0"
})(["padding-block-start:12px;padding-inline-start:8px;column-gap:16px;", ""], p => p.singleColumn && css(["justify-content:end;"]));
const GridSecondary = styled(Atoms.Dumb.ColumnGrid).withConfig({
  displayName: "Footer__GridSecondary",
  componentId: "o161ez-1"
})(["column-gap:16px;"]);
const PRIVACY_SETTINGS_CHANGED_EVENT = 'prezi:privacy:settings:changed';
const Footer = ({
  children,
  onDismissClicked,
  hasIncreasedPadding,
  settingsChanged = false
}) => {
  const handleDismiss = () => {
    onDismissClicked();
    if (settingsChanged) {
      window.dispatchEvent(new CustomEvent(PRIVACY_SETTINGS_CHANGED_EVENT));
    }
  };
  return React.createElement(Atoms.Dumb.FooterContainer, {
    hasIncreasedPadding: hasIncreasedPadding
  }, React.createElement(Bento.Divider, null), React.createElement(GridPrimary, {
    singleColumn: !children
  }, children && React.createElement(GridSecondary, null, children), React.createElement(Atoms.Dumb.Button, {
    variant: "default",
    onClick: handleDismiss,
    "data-lookup": "share-dialog-done-button"
  }, React.createElement("span", null, uxCopy.dismissModal))));
};
export default Footer;